import {enableProdMode, NgZone} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
//import 'zone.js/dist/zone';

if (environment.production) {
  console.log('Booting Production...');
  enableProdMode();
}else{
  console.log('Booting Dev...');
  /*
  platformBrowserDynamic().bootstrapModule(AppModule)
    .then(moduleRef => {
      const applicationRef = moduleRef.injector.get(ApplicationRef);
      const componentRef = applicationRef.components[0];
      // allows to run `ng.profiler.timeChangeDetection();`
      enableDebugTools(componentRef);
    })
    .catch(err => console.log(err));
    */
}
/**
 * All the following to go around a race condition with zone.js that seems to appear on FF and Safari.
 *
 */
// if the zone has already been loaded, go ahead an bootstrap the app
if (window['Zone']) {
  bootstrap();

// otherwise, wait to bootstrap the app until zone.js is imported
} else {
  // @ts-ignore
  import('zone.js/dist/zone').then(() => bootstrap());
}

function bootstrap() {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.log(err));
}

//platformBrowserDynamic().bootstrapModule(AppModule, { ngZone: new NgZone({}) });


